import { render, staticRenderFns } from "./PartnerComponent.vue?vue&type=template&id=6a208bf6&"
import script from "./PartnerComponent.vue?vue&type=script&lang=js&"
export * from "./PartnerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports